/**
 * Guest upload limits, checked before a file is queued and quoted in the upload panel.
 *
 * These mirror the limits the API signs into every upload URL (`x-goog-content-length-range`):
 * MAX_PHOTO_UPLOAD_BYTES / MAX_VIDEO_UPLOAD_BYTES in wedding-functions/controllers/mediaController.js.
 * uploadLimits.test.js reads those API constants and fails if this file drifts from them.
 */
const BYTES_PER_MIB = 1024 * 1024;

export const MAX_PHOTO_UPLOAD_BYTES = 50 * BYTES_PER_MIB; // covers all phone photos & DSLR JPEGs
export const MAX_VIDEO_UPLOAD_BYTES = 500 * BYTES_PER_MIB; // ~2-3 min of 4K phone video

/**
 * "50 MB" for a 50 MiB limit. Rounds down and uses the plain "MB" label guests recognise, so the
 * copy never promises more than is enforced (50 MiB is larger than 50 MB).
 */
function formatUploadLimit(bytes) {
  return `${Math.floor(bytes / BYTES_PER_MIB)} MB`;
}

export const PHOTO_UPLOAD_LIMIT_LABEL = formatUploadLimit(MAX_PHOTO_UPLOAD_BYTES);
export const VIDEO_UPLOAD_LIMIT_LABEL = formatUploadLimit(MAX_VIDEO_UPLOAD_BYTES);

/** "Photos up to 50 MB, videos up to 500 MB" */
export const UPLOAD_LIMIT_SUMMARY = `Photos up to ${PHOTO_UPLOAD_LIMIT_LABEL}, videos up to ${VIDEO_UPLOAD_LIMIT_LABEL}`;
